<template>
  <sliding-window>
    <div slot="panel">
      <h3>Index visuel ({{ density }} objets par format A4)</h3>
      <hr />
      <vertical-field>
        <label for="" slot="label" class="label"
          >Titre (ou laisser vide) :</label
        >
        <input type="text" class="input" v-model="title" />
      </vertical-field>
      <vertical-field v-if="pm.format === 'A3'">
        <label for="" slot="label" class="label"
          >Titre secondaire (ou laisser vide) :</label
        >
        <input type="text" class="input" v-model="titlesecond" />
      </vertical-field>
      <h3 class="subtitle">Densité</h3>
      <div class="field">
        <label class="radio"
          >6<input type="radio" value="6" name="density" v-model="density"
        /></label>
        <label class="radio"
          >12<input type="radio" value="12" name="density" v-model="density"
        /></label>
      </div>
      <hr />
      <h3 class="subtitle">Format</h3>
      <div class="field">
        <label class="radio"
          >A4 <input type="radio" value="A4" name="format" v-model="pm.format"
        /></label>
        <label class="radio"
          >A3 <input type="radio" value="A3" name="format" v-model="pm.format"
        /></label>
      </div>
      <hr />
      <div class="field">
        <div class="control">
          <button
            class="button"
            @click="print"
            :class="loading ? 'is-loading' : ''"
          >
            <i class="fa fa-print"></i>&nbsp;imprimer (serveur)
          </button>
          &nbsp;
          <button class="button" @click="printManual">
            <i class="fa fa-print"></i>&nbsp;imprimer (manuel)
          </button>
        </div>
      </div>
      <hr />
      <div class="control" v-if="render">
        <div class="RenderPreview">
          <img class="RenderPreview__img" :src="render.thumbnail.public_path" />
        </div>
        <a class="button is-info" :href="render.friendly_path" target="_blank"
          >Télécharger</a
        >
      </div>
      <hr />
      <div class="control">
        <router-link :to="'/home'"
          ><i class="fa fa-arrow-left"></i> accueil</router-link
        >
      </div>
    </div>
    <slot>
      <space>
        <page v-for="(chunk, index) in chunks" :key="index" :format="pm.format">
          <page-inner>
            <fiche-portrait-index
              :index="index"
              :title="title"
              :titlesecond="titlesecond"
              :format="pm.format"
              :density="parseInt(density, 10)"
              :total="chunks.length"
              :projects="chunk"
            ></fiche-portrait-index>
          </page-inner>
        </page>
      </space>
    </slot>
  </sliding-window>
</template>

<script>
import Space from "../../../PrintComponents/Workspace/DrawingSpace";
import SlidingWindow from "../../../PrintComponents/Workspace/SlidingWindow";
import FichePortraitIndex from "./FichePortraitIndex";
import { types as t } from "../../../../../store/actions/projects";
import Page from "../../../PrintComponents/Page/Page";
import VerticalField from "../../../../../components/Form/VerticalField";
import PageInner from "../../../PrintComponents/Page/PageInner";
import _ from "lodash";
import { types } from "../../../../../store/actions/render";
import { get, rem } from "../../../../../storage/storage";

export default {
  name: "Index",
  components: {
    PageInner,
    VerticalField,
    Page,
    FichePortraitIndex,
    SlidingWindow,
    Space
  },
  data() {
    return {
      projects: [],
      density: "6",
      title: "",
      titlesecond: "",
      pm: {
        format: "A4"
      },
      loading: false,
      bar: 0.5,
      drag: false,
      render: null
    };
  },
  props: {
    ids: {}
  },
  methods: {
    printManual() {
      setTimeout(() => {
        window.print();
      }, 300);
    },
    async print() {
      this.loading = true;
      await new Promise(r => setTimeout(r, 500));
      const render = await this.$store.dispatch(types.EXPORT_A4_PROJECT, {
        payload: JSON.stringify(this.$data),
        url: window.location.href,
        range: `1-${this.chunks.length}`,
        timeout: 2000 + this.chunks.length * 1500,
        friendly_name: `${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}-index${
          this.title ? "-" + this.title : ""
        }.pdf`.replace(/(\s|\/|:)/gi, "-")
      });
      this.render = render;
      this.loading = false;
    }
  },
  computed: {
    chunks() {
      const n = (this.pm.format === "A3" ? 2 : 1) * parseInt(this.density, 10);
      const chunked = _.chunk(this.projects, n);
      return chunked;
    }
  },
  async mounted() {
    if (window.HEADLESS) {
      const d = await this.$store.dispatch(
        types.GET_RENDERING_PAYLOAD,
        get("payload")
      );
      for (let prop in d) {
        this.$set(this, prop, d[prop]);
      }
      rem("payload");
    } else {
      this.projects = await this.$store.dispatch(
        t.GET_PROJECTS_BY_IDS_D,
        this.ids
      );
      rem("payload");
    }
  }
};
</script>
